import { WorkflowValidityError } from './workflow-validity-error';
import { WorkflowValidityWarning } from './workflow-validity-warning';

/**
 * Représente le rapport généré suite à la validation d'un workflow.
 */
export class WorkflowValidityReport {
    /**
     * Liste des erreurs remontées par la validation du workflow.
     */
    errors: WorkflowValidityError[] = [];

    /**
     * Liste des avertissements remontées par la validation du workflow.
     */
    warnings: WorkflowValidityWarning[] = [];

    /**
     * Valeur indiquant si le workflow est valide.
     */
    isValid: boolean = null;

    /**
     * Retourne une copie d'une instance de WorkflowValidityReport
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: WorkflowValidityReport) {
        if (!!other) {
            const instance = new WorkflowValidityReport();
            instance.errors = WorkflowValidityError.cloneArray(other.errors);
            instance.warnings = WorkflowValidityWarning.cloneArray(other.warnings);
            instance.isValid = other.isValid;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de WorkflowValidityReport
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: WorkflowValidityReport[]) {
        if (!!others) {
            let reports: WorkflowValidityReport[] = [];

            others.forEach((x) => {
                const report = WorkflowValidityReport.clone(x);
                reports.push(report);
            });

            return reports;
        } else {
            return [];
        }
    }
}
